import styled from 'styled-components';

import {
  MOBILE_PADDING,
  NAVIGATION_MOBILE_HEIGHT,
  NAVIGATION_DESKTOP_HEIGHT,
  PAGE_WIDTH,
  BLACK,
  TEXT_GRAY,
} from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: -${NAVIGATION_MOBILE_HEIGHT}px auto 0;
  padding: ${NAVIGATION_MOBILE_HEIGHT}px ${MOBILE_PADDING}px 20px;
  text-align: center;
  background: ${({ color }) => color};

  ${media.tabletL`
    padding: ${NAVIGATION_DESKTOP_HEIGHT}px 20px 45px;
    margin-top: -${NAVIGATION_DESKTOP_HEIGHT}px;
  `};
`;

export const Texts = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 175px;
  justify-content: center;
  width: 100%;

  ${media.tabletL`
    height: 300px;
  `};

  ${({ isImageAtTheTop }) =>
    isImageAtTheTop &&
    `
    order: 2;
    height: unset !important;
  `};
`;

export const Title = styled.h1`
  font-size: 30px;
  margin: ${({ isImageAtTheTop }) => (isImageAtTheTop ? '30px 0 0' : '10px 0 20px')};

  text-transform: ${({ doNotCapitalizeTheTitle }) => (doNotCapitalizeTheTitle ? 'unset' : 'uppercase')};
  text-align: left;
  width: 955px;
  max-width: 100%;
  color: ${BLACK};
  letter-spacing: 0.8px;
  line-height: 40px;

  ${media.tabletL`
    color: ${TEXT_GRAY.COMMON_6};
    font-size: 48px;
    text-align: center;
    line-height: 67px;
    margin: ${({ isImageAtTheTop }) => (isImageAtTheTop ? '50px 0 0' : '20px 0 30px')};
  `};
`;

export const SubTitle = styled.h4`
  width: 100%;
  margin: 0;
  color: ${BLACK};
  font-size: 15px;
  line-height: 17px;
  font-weight: 400;

  ${media.tabletL`
    font-size: 18px;
    line-height: 20px;
  `};
`;

export const ImageWrapper = styled.div`
  max-height: 700px;
  max-width: 100%;
  width: 1050px;

  ${media.tabletL`
    margin: 0 auto;
  `};

  ${({ isImageAtTheTop }) =>
    isImageAtTheTop &&
    `
    order: 1;
    margin: 10px auto 0;
    ${media.tabletL`
      margin: 40px auto 0;
    `};
  `};
`;

export const SeasonCopyWrapper = styled.div`
  margin: 20px 0;
  text-align: left;

  ${media.tabletL`
    margin: 40px auto 0 auto;
  `};

  &.pc {
    max-width: 100%;
    width: 1050px;
  }

  ${({ isImageAtTheTop }) =>
    isImageAtTheTop &&
    `
    order: 3;
  `};
`;

export const MarkdownStyle = styled.div`
  h1 {
    color: ${TEXT_GRAY.COMMON_6};
    font-size: 22px;
    line-height: 28px;
    text-align: left;
    ${media.tabletL`
      color: ${BLACK};
      text-align: center;
      font-size: 30px;
      line-height: 32px;
    `};
  }

  h3 {
    color: ${BLACK};
    font-size: 22px;
    line-height: 24px;
    ${media.tabletL`
      font-size: 30px;
      line-height: 32px;
    `};
  }

  p {
    margin: 12px auto 0;
    color: ${TEXT_GRAY.COMMON_5};
    font-size: 14px;
    max-width: 850px;

    ${media.tabletL`
      font-size: 18px;
    `};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/EditorialHero/EditorialHero.style.js